import { createReducer, on } from '@ngrx/store';
import {
  LoadInsights,
  LoadInsightsCsv,
  SetInsights,
  InsightsCsvLoaded,
  SetInsightsApiError,
  RemoveInsightsApiError,
} from './insights.actions';
import { InsightsApiError } from './insights.errors';
import { CallStateLoadInsights } from './insights.enum';
import { Insights } from './insights.model';

export interface InsightsState {
  insights: Insights;
  callStateLoadInsights: CallStateLoadInsights;
  apiError: InsightsApiError;
}

export const initialState: InsightsState = {
  insights: null,
  callStateLoadInsights: CallStateLoadInsights.INIT,
  apiError: null,
};

export const insightsReducer = createReducer(
  initialState,
  on(LoadInsights, LoadInsightsCsv, (state) => ({
    ...state,
    callStateLoadInsights: CallStateLoadInsights.LOADING,
  })),
  on(SetInsights, (state, { insights }) => ({
    ...state,
    callStateLoadInsights: CallStateLoadInsights.LOADED,
    insights,
  })),
  on(InsightsCsvLoaded, (state) => ({
    ...state,
    callStateLoadInsights: CallStateLoadInsights.LOADED,
  })),
  on(SetInsightsApiError, (state, { error }) => ({
    ...state,
    apiError: error,
    callStateLoadInsights: CallStateLoadInsights.ERROR,
  })),
  on(RemoveInsightsApiError, (state) => ({
    ...state,
    apiError: null,
  })),
);
